import { Outlet, RouteObject } from "react-router-dom";
import { AuthGuard } from "../app/auth";
import { Page } from "./page";

export const orderRoutes: RouteObject[] = [
  {
    handle: { breadcrumb: "Home" },
    element: (
      <AuthGuard>
        <Outlet />
      </AuthGuard>
    ),
    children: [
      {
        index: true,
        path: "",
        lazy: async () => {
          const { Orders } = await import("./orders");
          return {
            element: (
              <Page>
                <Orders />
              </Page>
            ),
          };
        },
      },
      {
        path: ":id",
        lazy: async () => {
          const { Order } = await import("./order");
          return { Component: Order };
        },
        children: [
          {
            handle: { breadcrumb: "Order Details" },
            path: "",
            lazy: async () => {
              const { OrderDetails } = await import("./order-details");
              return { Component: OrderDetails };
            },
            children: [
              {
                handle: { breadcrumb: "Tracking" },
                path: "track/:fulfillmentIndex",
                lazy: async () => {
                  const { Fulfillment } = await import(
                    "./order-tracking/fulfillment"
                  );
                  return { Component: Fulfillment };
                },
              },
            ],
          },
          {
            path: ":returnType",
            lazy: async () => {
              const { ReturnFlow } = await import("./returnFlow/return-flow");
              return { Component: ReturnFlow };
            },
          },
          {
            path: "exchange",
            lazy: async () => {
              const { AdvancedExchangeWrapper } = await import(
                "./returnFlow/cardContents/advanced-exchange-wrapper"
              );
              return { Component: AdvancedExchangeWrapper };
            },
          },
        ],
      },
      {
        path: "return/:id",
        lazy: async () => {
          const { ReturnStatus } = await import("./return-status");
          return {
            element: (
              <Page>
                <ReturnStatus />
              </Page>
            ),
          };
        },
      },
    ],
  },
];
